import { CHANGE_PAGE_HEADER, SET_MAIN_ELEMENT, GET_API_CONFIG,GET_API_CONFIG_START } from "./AppActions";
import { FETCH_SIGNATURE_START, FETCH_SIGNATURE_SUCCESS, FETCH_SIGNATURE_FAILURE, SAVE_SIGNATURE, SAVE_SIGNATURE_SUCCESS, SAVE_SIGNATURE_FAILURE } from "../signature/SignatureActions";
import {
    DESTROY_ACCOUNT_START, GET_ACCOUNT_PII_START, GET_ACCOUNT_PII_STATUS_START,
    GET_DESTROY_STATUS_START,
    DELETE_SHARE_START
} from "../delete-account/DeleteAccountActions";
import {
    DESTROY_ACCOUNT, DESTROY_ANY_MAIL_ACCOUNT, GET_ACCOUNT_PII, DELETE_SHARE, GET_ACCOUNT_PII_STATUS, GET_ANY_MAIL_ACCOUNT_PII,
    GET_BRAND,
    GET_DESTROY_STATUS, GET_ENV
} from "../../redux/types";
import { GET_BRAND_START } from "../../components/brand/BrandActions";

const INITIAL_STATE = {
    page: '',
    snackBar: '',
    loading: false,
    loadingBackDrop: false,
    leftDrawer: false,
    mainElement: null,
    env: 'production',
    stripe: { enabled: true }
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case CHANGE_PAGE_HEADER:
            return { ...state, ...action.payload };
        case SET_MAIN_ELEMENT:
            return { ...state, mainElement: action.payload };
        case GET_ENV:
            return { ...state, env: action.payload.data };
        case GET_DESTROY_STATUS_START:
        case GET_ACCOUNT_PII_START:
        case GET_BRAND_START:
            return { ...state, loading: true };
        case FETCH_SIGNATURE_START:
            return { ...state, loading: true };
        case FETCH_SIGNATURE_SUCCESS:
            return { ...state, data: action.payload, loading: false };
        case FETCH_SIGNATURE_FAILURE:
            return { ...state, data: action.payload, loading: false };

        case GET_DESTROY_STATUS:
        case GET_ACCOUNT_PII:
        case GET_ANY_MAIL_ACCOUNT_PII:
        case GET_BRAND:
        case DELETE_SHARE:
            return {...state, loading: false};
        case DESTROY_ACCOUNT_START:
            return { ...state, loadingBackDrop: true };
        case DESTROY_ACCOUNT:
        case DESTROY_ANY_MAIL_ACCOUNT:
            return {...state, loadingBackDrop: false};
        case GET_API_CONFIG_START:
            return { ...state, fetching: true };
        case GET_API_CONFIG:
            if (action.error) {
                return { ...state, error: action.payload.message, fetching: false };
            }
            return { ...state, ...action.payload.data, fetching: false };
    }
    return state;
};



// WEBPACK FOOTER //
// ./src/containers/app/AppReducer.js